var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"staffRank"},[_vm._v("staffRank组件测试")])}
var staticRenderFns = []

export { render, staticRenderFns }